<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="能耗概括" name="energy">
        <el-button size="small" type="primary" @click="energyAdd()"
          >添加</el-button
        >
        <el-table
          :data="energyData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="type" label="类型" width="180">
            <template slot-scope="scope">
              {{
                scope.row.type == "year"
                  ? "年"
                  : scope.row.type == "month"
                  ? "月"
                  : scope.row.type == "day"
                  ? "日"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="更新时间">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="energySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="energyEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                autofocus
                type="danger"
                @click="energyDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="值班人员" name="duty">
        <el-button size="small" type="primary" @click="dutyAddMenu()"
          >添加</el-button
        >
        <el-table
          :data="dutyData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="duty_hours" label="值班时间">
          </el-table-column>
          <el-table-column label="地点">
            <template slot-scope="scope">
              <div class="line2">
                {{ scope.row.location }}
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="dutySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="dutyEditCz(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="dutyDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="dutyPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="dutySize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dutyTotal"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 能耗概况 -->
    <el-dialog
      :title="energyTitle"
      :visible.sync="energyFormVisible"
      width="500px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="energyForm"
        ref="energyForm"
        :rules="energyRules"
      >
        <el-form-item label="类型" prop="type">
          <el-radio-group
            :disabled="energyCz == 'see'"
            v-model="energyForm.type"
            @input="energyRadio"
          >
            <el-radio label="year">年</el-radio>
            <el-radio label="month">月</el-radio>
            <el-radio label="day">日</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="配置信息">
          <div style="max-height: 300px; overflow: auto">
            <div
              style="display: flex"
              v-for="(item, index) in energyForm.value"
              :key="index"
            >
              <span
                >{{ index < 9 ? "0" + (index + 1) : index + 1
                }}{{
                  energyForm.type == "year"
                    ? "月"
                    : energyForm.type == "month"
                    ? "日"
                    : energyForm.type == "day"
                    ? "时"
                    : ""
                }}：</span
              >
              <el-input
                type="number"
                min="0"
                class="numInput"
                :disabled="energyCz == 'see'"
                size="small"
                v-model="item.water"
                auto-complete="off"
                placeholder="请输入总电能能耗"
                style="width: 150px"
              ></el-input>
              <el-input
                type="number"
                min="0"
                class="numInput"
                :disabled="energyCz == 'see'"
                size="small"
                v-model="item.electricity"
                auto-complete="off"
                placeholder="请输入总水能能耗"
                style="width: 150px"
              ></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="energyCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="energySubmit('energyForm')"
          >保存</el-button
        >
        <el-button
          v-if="energyCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="energyTjEdit('energyForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 值班人员 -->
    <el-dialog
      :title="dutyTitle"
      :visible.sync="dutyFormVisible"
      width="500px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="dutyForm"
        ref="dutyForm"
        :rules="dutyRules"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            :disabled="dutyCz == 'see'"
            v-model="dutyForm.name"
            auto-complete="off"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="值班时间" prop="duty_hours">
          <el-input
            :disabled="dutyCz == 'see'"
            v-model="dutyForm.duty_hours"
            auto-complete="off"
            placeholder="请输入值班时间"
          ></el-input>
        </el-form-item>
        <el-form-item label="地点" prop="location">
          <el-input
            v-model="dutyForm.location"
            auto-complete="off"
            placeholder="请输入地点"
            :disabled="dutyCz == 'see'"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="dutyCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="dutyAdd('dutyForm')"
          >添加</el-button
        >
        <el-button
          v-if="dutyCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="dutyEdit('dutyForm')"
          >提交编辑</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  // wcZhwyEnergyList,
  // wcZhwyEnergyDetail,
  // wcZhwyEnergyDel,
  // wcZhwyEnergyEdit,
  // wcZhwyEnergyAdd,
  // wcZhwyDutyList,
  // wcZhwyDutyDetail,
  // wcZhwyDutyDel,
  // wcZhwyDutyEdit,
  // wcZhwyDutyAdd,
} from "@/api/wuchang";
export default {
  components: {},
  data() {
    return {
      loading: false, //是显示加载
      activeName: "energy",
      // 能耗
      energyData: [],
      energyForm: {
        type: "",
        value: [],
      },
      energyFormVisible: false,
      energyTitle: "添加",
      energyCz: "",
      energyRules: {
        // type: [
        //   { required: true, message: "请输入项目名称", trigger: "blur" },
        // ],
        value: [{ required: true, message: "请输入配置信息", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      oldEnergyForm: {},
      // 值班人员
      dutyData: [],
      dutyForm: {},
      dutyCz: "",
      dutyRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        duty_hours: [
          { required: true, message: "请输入值班时间", trigger: "blur" },
        ],
        location: [{ required: true, message: "请输入地点", trigger: "blur" }],
      },
      dutyTitle: "",
      dutyFormVisible: false,
      dutyPage: 1,
      dutyTotal: 0,
      dutySize: 15,
    };
  },
  computed: {},
  mounted() {
    this.getEnergyList();
  },
  methods: {
    // 添加值班人员菜单
    dutyAddMenu() {
      this.dutyFormVisible = true;
      this.dutyTitle = "添加";
      this.dutyCz = "add";
      this.dutyForm = {
        name: "",
        duty_hours: "",
        location: "",
      };
    },
    // 重点项目分页
    handleSizeChange(val) {
      this.dutySize = val;
      this.getDutyList();
    },
    // 重点项目分页
    handleCurrentChange(val) {
      this.dutyPage = val;
      this.getDutyList();
    },
    // 值班人员-列表
    getDutyList() {
      let data = {
        page: this.dutyPage,
        page_size: this.dutySize,
      };
      wcZhwyDutyList(data).then((res) => {
        this.dutyTotal = res.data.total;
        this.dutyData = res.data.data;
      });
    },
    // 值班人员-新增
    dutyAdd(formName) {
      var that = this;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            name: that.dutyForm.name,
            location: that.dutyForm.location,
            duty_hours: that.dutyForm.duty_hours,
          };
          wcZhwyDutyAdd(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getDutyList();
              that.dutyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 值班人员-编辑
    dutyEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: that.dutyForm.id,
            name: that.dutyForm.name,
            location: that.dutyForm.location,
            duty_hours: that.dutyForm.duty_hours,
          };
          wcZhwyDutyEdit(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getDutyList();
              that.dutyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },

    // 值班人员-删除
    dutyDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          wcZhwyDutyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getDutyList();
          });
        })
        .catch(() => {});
    },
    // 能耗概括-表格查看操作
    dutySee(val) {
      this.dutyTitle = "查看";
      this.dutyCz = "see";
      this.dutyInfo(val.id);
      this.dutyFormVisible = true;
    },
    // 值班人员-表格编辑操作
    dutyEditCz(val) {
      this.dutyTitle = "编辑";
      this.dutyCz = "edit";
      this.dutyInfo(val.id);
      this.dutyFormVisible = true;
    },
    // 值班人员-详情
    dutyInfo(id) {
      wcZhwyDutyDetail({ id: id }).then((res) => {
        this.dutyForm = {
          id: res.data.id,
          name: res.data.name,
          location: res.data.location,
          duty_hours: res.data.duty_hours,
        };
      });
    },

    // 重点项目宣传-新增
    energySubmit(formName) {
      var that = this;
      // return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            type: that.energyForm.type,
            value: JSON.stringify(that.energyForm.value),
          };
          wcZhwyEnergyAdd(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getEnergyList();
              that.energyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 能耗概括-编辑
    energyTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: that.energyForm.id,
            type: that.energyForm.type,
            value: JSON.stringify(that.energyForm.value),
          };
          wcZhwyEnergyEdit(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getEnergyList();
              that.energyFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 能耗概括-删除
    energyDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          wcZhwyEnergyDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getEnergyList();
          });
        })
        .catch(() => {});
    },
    // 能耗概括-详情
    energyInfo(id) {
      wcZhwyEnergyDetail({ id: id }).then((res) => {
        this.energyForm = {
          id: res.data.id,
          type: res.data.type,
          value: JSON.parse(res.data.value),
        };
      });
    },
    // 添加能耗概括
    energyAdd() {
      this.energyFormVisible = true;
      this.energyTitle = "添加";
      this.energyCz = "add";
      this.energyForm = {
        type: "year",
        value: "",
      };
      this.energyRadio("year");
    },
    // 能耗概括-表格编辑操作
    energyEdit(val) {
      this.energyTitle = "编辑";
      this.energyCz = "edit";
      this.energyInfo(val.id);
      this.oldEnergyForm = {
        type: val.type,
        value: JSON.parse(val.value),
      };
      this.energyFormVisible = true;
    },
    // 能耗概括-表格查看操作
    energySee(val) {
      this.energyTitle = "查看";
      this.energyCz = "see";
      this.energyInfo(val.id);
      this.energyFormVisible = true;
    },
    // 能耗概括-列表
    getEnergyList() {
      wcZhwyEnergyList().then((res) => {
        this.energyData = res.data;
      });
    },
    // 切换能耗类型
    energyRadio(e) {
      var that = this;
      that.energyForm.value = [];
      if (e == that.oldEnergyForm.type) {
        that.energyForm.value = that.oldEnergyForm.value;
      } else {
        if (e == "year") {
          for (var i = 0; i < 12; i++) {
            that.energyForm.value.push({
              water: "",
              electricity: "",
              time: i + 1,
              time_type: "M",
            });
          }
        } else if (e == "month") {
          let date = new Date();
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          let d = new Date(year, month, 0);
          for (var i = 0; i < d.getDate(); i++) {
            that.energyForm.value.push({
              sn: "",
              dn: "",
              time: i + 1,
              time_type: "D",
            });
          }
        } else if (e == "day") {
          for (var i = 0; i < 24; i++) {
            that.energyForm.value.push({
              sn: "",
              dn: "",
              time: i + 1,
              time_type: "H",
            });
          }
        }
      }
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.dutyFormVisible = false;

      this.energyFormVisible = false;
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getEnergyList();
      } else if (tab.index == 1) {
        this.getDutyList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
